import Vcalendar from '@angelblanco/v-calendar'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Vcalendar)
})
